import React, { useState, useCallback, useRef } from 'react';

const MIN_HEIGHT = 150;

export default function ResizableChart({ defaultHeight, children }) {
  const [height, setHeight] = useState(defaultHeight);
  const dragging = useRef(false);
  const startY = useRef(0);
  const startH = useRef(0);

  const onMouseDown = useCallback((e) => {
    e.preventDefault();
    dragging.current = true;
    startY.current = e.clientY;
    startH.current = height;

    const onMouseMove = (ev) => {
      if (!dragging.current) return;
      const delta = ev.clientY - startY.current;
      setHeight(Math.max(MIN_HEIGHT, startH.current + delta));
    };

    const onMouseUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }, [height]);

  return (
    <div style={{ position: 'relative' }}>
      {children(height)}
      <div
        onMouseDown={onMouseDown}
        style={{
          height: 16,
          cursor: 'ns-resize',
          background: 'transparent',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          flexDirection: 'column',
          opacity: 0.4,
          transition: 'opacity 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.8'; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.4'; }}
      >
        <svg width="20" height="10" viewBox="0 0 20 10" style={{ display: 'block' }}>
          <circle cx="4" cy="2" r="1.5" fill="var(--color-secondary, #888)" />
          <circle cx="10" cy="2" r="1.5" fill="var(--color-secondary, #888)" />
          <circle cx="16" cy="2" r="1.5" fill="var(--color-secondary, #888)" />
          <circle cx="4" cy="8" r="1.5" fill="var(--color-secondary, #888)" />
          <circle cx="10" cy="8" r="1.5" fill="var(--color-secondary, #888)" />
          <circle cx="16" cy="8" r="1.5" fill="var(--color-secondary, #888)" />
        </svg>
      </div>
    </div>
  );
}
